export default "__VITE_ASSET__c96fe5b3__"